import { render, staticRenderFns } from "./OrganizationSubscriptionLicences.vue?vue&type=template&id=d6615c26"
import script from "./OrganizationSubscriptionLicences.vue?vue&type=script&lang=js"
export * from "./OrganizationSubscriptionLicences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports